import http from './http'
import { NUMERO_TWILIO_FAST, ESCUELA_FAST, parseChatsResponse } from './constantes'

export function loginVendedoraRh (email, password) {
  return http.post('usuarios.data', { email, password })
}

export function fetchChats ({ idusuario, offset = 0, limit = 2000 } = {}) {
  return http.post('twilio.chats', {
    twilio: NUMERO_TWILIO_FAST,
    idusuario,
    escuela: ESCUELA_FAST,
    offset,
    limit,
  }).then((res) => parseChatsResponse(res.data))
}

export function fetchChatUnico (usuario) {
  return http.post('twilio.chats.unico', {
    twilio: NUMERO_TWILIO_FAST,
    usuario,
  }).then((res) => res.data)
}

export function fetchEtiquetas () {
  return http.get('twilio.etiquetas').then((res) => res.data)
}

export function fetchAccesoCrm (iderp) {
  return http.get('twilio.acceso.crm/' + iderp).then((res) => res.data)
}

export function fetchVendedorasList () {
  return http.get('vendedoras.list').then((res) => res.data)
}

export function setEtiquetaChat ({ twilio, usuario, etiqueta, usuario_cambio }) {
  return http.post('twilio.etiqueta', { twilio, usuario, etiqueta, usuario_cambio })
}

export function fetchComentariosProspecto (idProspecto) {
  return http.get('api/comentarios-prospectos/' + idProspecto).then((res) => res.data)
}

export function addComentarioProspecto ({ id_prospecto, comentario, nombre_usuario }) {
  return http.post('api/comentarios-prospectos', { id_prospecto, comentario, nombre_usuario })
}

export function parseAudio (blob, mimeType) {
  return http.post('audio.parse', blob, {
    headers: { 'Content-Type': mimeType || 'audio/mpeg' },
    transformRequest: [(data) => data],
  }).then((res) => res.data)
}

export function sendMessage (formData) {
  return http.post('twilio.send.message', formData)
}

export function reasignarProspectosMasivo (payload) {
  return http.post('reasignar.prospectos.masivo', payload).then((res) => res.data)
}
